module.exports = __webpack_public_path__ + "media/images/arrow-right-f456a7e23f26ddacf6eccc58b6847677.svg";